import { DetailPluginLock } from '../basic/interface_lock/DetailPluginLock';
import BioFunctionBarService from './service/BioFunctionBarService';
import BioListOperationService from './service/BioOperationService';
import { MicroApp } from './micro';
import _ from 'lodash';
import responseKeyNormalizerMapping from './mapping';
export default class BioDetailPlugin extends DetailPluginLock {
    constructor() {
        super(responseKeyNormalizerMapping.pluginName);
        // @ts-ignore
        this.responseKeyNormalizerMapping = Object.freeze(responseKeyNormalizerMapping);
        this.silencedUpdateQueryKeys = ['page', 'sort', 'tab'];
        this.microapp = new MicroApp(this.microAppId);
    }
    get enabled() {
        return localStorage.getItem('workspaceDetail:seq') !== 'false';
    }
    _queryParamsNormalizer(route) {
        return super._queryParamsNormalizer(route);
    }
    get ListOperationServiceClass() {
        return BioListOperationService;
    }
    get FunctionBarServiceClass() {
        return BioFunctionBarService;
    }
    get isRefineEnabled() {
        return true;
    }
    get basicInfo() {
        return {
            key: this.name,
            index: 2,
            label: `dataType.${this.name}`,
            entryRoute: { name: 'detailBioRoot' },
        };
    }
    getReloadIdentifier(route) {
        const params = this._queryParamsNormalizer(route);
        return JSON.stringify(_.omit(params, this.silencedUpdateQueryKeys));
    }
    getPluginSubRouteConfig() {
        const self = this;
        function getDetailPageProps(route) {
            return {
                ...self.commonProps,
                ...self._queryParamsNormalizer(route),
            };
        }
        return {
            path: this.name,
            name: 'detailBioRoot',
            // @ts-ignore
            component: () => import('./BioDetail.vue'),
            props: getDetailPageProps,
        };
    }
    _preload() {
        this.microapp.preload();
        return Promise.resolve();
    }
}
